import { createFlatKey } from '../addresses';
import { importTypes, settingStepFieldKeys } from '../../config/import';

const ownerKeys = settingStepFieldKeys[importTypes.owners];

const flatNotExistMsg = 'Отсутствует данное помещение';
const hasClientByPhoneMsg = '(По номеру телефона собственник обнаружен)';

const checkIsFlatExist = ({ data, typeId, name }) => {
  const flatKey = createFlatKey({ typeId, name });
  return Boolean(data[flatKey]);
};

const createErrors = (hasClientByPhone) =>
  hasClientByPhone
    ? `${flatNotExistMsg} ${hasClientByPhoneMsg}`
    : flatNotExistMsg;

const getProcessClient =
  ({ clientsByPhone, flatsByTypeAndName, valid, invalid }) =>
  (client) => {
    const {
      [ownerKeys.addressType]: typeId,
      [ownerKeys.flat]: name,
      [ownerKeys.phone]: phone,
    } = client;

    const existingClientsByPhone = clientsByPhone[phone];
    const isFlatExist = checkIsFlatExist({
      data: flatsByTypeAndName,
      typeId,
      name,
    });

    isFlatExist
      ? valid.push(client)
      : invalid.push({
          ...client,
          errors: createErrors(Boolean(existingClientsByPhone)),
        });
  };

export const checkOwners = ({ validationResult, data }) => {
  const valid = [];
  const invalid = validationResult.invalid.slice();

  const processClient = getProcessClient({ ...data, valid, invalid });

  validationResult.valid.forEach(processClient);

  return { valid, invalid };
};
